<template>
  <div class="k-audio-wrap">
    <audio
      class="k-audio js-k-audio"
      src="https://staticcdn-yy-prd.pydp888.com/data/mp3/none.mp3"
      crossorigin="anonymous"
    />
  </div>
</template>

<script>
import { isFunction } from '../../utils/xp.v1'
import { WZ } from '../../utils/wz.v2'
import {
  MEDIA_STATUS_NONE,
  MEDIA_STATUS_PLAYING,
  MEDIA_STATUS_PAUSED,
  MEDIA_STATUS_ENDED
} from '../../const/media'
import { mapGetters } from 'vuex'

const _AUDIO_ID = 'wz_om_player_' + (+new Date()).toString(36) + '_'
function getPlayer() {
  var p = document.getElementById(_AUDIO_ID)
  if (!p) {
    p = document.createElement('audio')
    p.className = 'wz_om_player'
    p.id = _AUDIO_ID
    p.controls = true
    p.src = 'https://staticcdn-yy-prd.pydp888.com/data/mp3/none.mp3'
    document.body.appendChild(p)
    // audio_init(p);

    // fix  苹果端问题
    const click = () => {
      // document.removeEventListener("click", click);
      document.removeEventListener('touchstart', click, false)
      document.removeEventListener('WeixinJSBridgeReady', click, false)
      const player = document.getElementById(_AUDIO_ID)
      if (player) {
        player.play()
      }
    }
    document.addEventListener('touchstart', click, false)
    document.addEventListener('WeixinJSBridgeReady', click, false)
  }
  return p
}

getPlayer()

export default {
  name: 'k-audio',
  data() {
    return {
      // canplay: false,
      // canplaythrough: false,
      status: MEDIA_STATUS_NONE,
      time: 0, //currentTime
      seconds: 0,
      muted: false,
      volume: 1,
      duration: 0,
      hasInit: false,
      // playing: false,
      hasTouched: false,
      listeners: {},
      error: ''
    }
  },
  props: ['src', 'toggle'],
  computed: {
    ...mapGetters(['inEnvDev']),
    // player() {
    //   return getPlayer()
    // },
    isPlaying() {
      return this.status === MEDIA_STATUS_PLAYING
      // return !!this.src && !!this.playing
    }
    // duration() {
    //   return this.player ? this.player.duration : 0
    // },
    // volume() {
    //   return this.valOf('volume', 0)
    // },

    // crossOrigin() {
    //   return this.valOf("crossOrigin", 0);
    // },
  },
  methods: {
    valOf(name, defValue) {
      const player = getPlayer()
      if (player) {
        const v = player[name]
        return v != null ? v : defValue
      }
      return defValue
    },

    // 播放
    play() {
      const player = getPlayer()
      if (player) {
        try {
          player.play()
        } catch (e) {
          this.error = `play: ${e.message || e}`
        }
      } else {
        this.error = 'play: no audio'
      }
    },

    // 暂停
    pause() {
      const player = getPlayer()
      if (player) {
        try {
          player.pause()
        } catch (e) {
          this.error = `pause: ${e.message || e}`
        }
      } else {
        this.error = 'pause: no audio'
      }
    },
    setStatus(status) {
      // 检测是否可设置
      this.status = status
    },
    setSrc(src) {
      const player = getPlayer()
      const { isPlaying, toggle } = this
      if (player) {
        player.src = src
        if (src && (isPlaying || toggle)) {
          player.play()
        } else {
          this.error = `src: ${!!src} isPlaying: ${toggle} isPlaying: ${toggle}`
        }
      } else {
        this.error = 'setSrc: no audio'
      }
    },

    on(evt, cb) {
      const player = getPlayer()
      if (player) {
        const listeners = this.listeners || {}
        this.listeners = listeners
        if(isFunction(cb)) {
          listeners[evt] = cb
          player.addEventListener(evt, cb, false)
        }
      } else {
        this.error = 'on: no audio'
      }
      return this
    },

    offAll() {
      const player = getPlayer()
      const { listeners } = this
      this.listeners = null
      if (player) {
        for (const evt in listeners) {
          if (isFunction(listeners[evt])) {
            player.removeEventListener(evt, listeners[evt])
          }
        }
      } else {
        this.error = 'offAll: no audio'
      }
    },

    onHide(data) {
      if (data && data.hasOwnProperty('visible') && data.visible === 0) {
        this.pause()
      }
    },

    // 同步数据
    sync(name, attrName) {
      const player = getPlayer()
      if (player) {
        attrName = attrName || name
        this[name] = player[attrName]
      } else {
        this.error = 'sync: no audio'
      }
    },
    emit(type, args) {
      const player = getPlayer()
      const { time, muted, volume, seconds } = this

      let duration = 0

      // let muted = false
      if (player) {
        duration = player.duration
        // muted = player.muted // 是否静音
      } else {
        this.error = 'emit: no audio'
      }

      this.$emit(type, {
        type,
        duration,
        time,
        seconds,
        muted,
        volume,
        ...args
      })
    },
    init() {
      if (this.hasInit) {
        return
      }
      this.hasInit = true
      
      /*
        事件顺序：
        play -> loadstart -> loadedmetadata -> loadeddata -> canplay-> playing -> canplaythrough -> timeupdate -> ticking -> pause -> ended
        */
      this.on('loadstart', () => {
        this.emit('loadstart', {}) // 会影响后续 duration 值
      })
        .on('loadedmetadata', () => {
          this.emit('loadedmetadata')
        })
        .on('loadeddata', () => {
          this.emit('loadeddata')
        })
        .on('playing', () => {
          this.sync('muted')
          this.sync('volume')
          this.setStatus(MEDIA_STATUS_PLAYING)
          this.emit('playing')
        })
        .on('timeupdate', () => {
          let time = +this.valOf('currentTime', 0)
          time = time.toFixed(1)
          this.time = +time
        })
        .on('pause', () => {
          this.setStatus(MEDIA_STATUS_PAUSED)
          this.emit('pause')
        })
        .on('ended', () => {
          this.setStatus(MEDIA_STATUS_ENDED)
          this.emit('ended')
        })
        .on('waiting', () => {
          //   this.playing = false
          this.emit('waiting')
        })
        .on('abort', () => {
          // this.abort = true
          this.emit('abort')
        })
        .on('canplay', () => {
          //   this.canplay = true
          this.emit('canplay')
        })
        .on('canplaythrough', () => {
          //   this.canplaythrough = true
          this.emit('canplaythrough')
        })
        .on('volumechange', () => {
          this.sync('muted')
          this.sync('volume')
          this.emit('volumechange')
        })

      // 设置
      if (this.src) {
        this.setSrc(this.src)
      }
      WZ.on('wzweb:exec:webview.setState', this.onHide)
    },
    tryInit(n) {
      const player = getPlayer()
      if(player) {
        this.init()
      } else if(n > 0) {
        setTimeout(() => this.tryInit(n-1), 50)
      }
    }
  },
  watch: {
    src(src) {
      // this.src = src
      this.setSrc(src)
    },
    // canplay() {
    //   const {isPlaying} = this
    //   if (isPlaying) {
    //     this.play()
    //   }
    // },
    time(ms) {
      this.seconds = Math.ceil(ms)
      this.emit('timeupdate', {})
    },
    // time(seconds) {
    //   // console.log({secs})
    //   this.emit("timeupdate", {});
    // },
    toggle() {
      if (this.toggle) {
        this.play()
      } else {
        this.pause()
      }
    }
  },
  mounted() {
    this.tryInit(10)
  },
  beforeDestroy() {
    WZ.off('wzweb:exec:webview.setState', this.onHide)
    this.offAll()
    this.listeners = null
  }
}
</script>
